import { useEffect } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router'
import { Button, Card } from '@wp-one/ui'
import { reportError } from './monitoring'

export function RootError() {
  const error = useRouteError()
  const title =
    isRouteErrorResponse(error) && error.status === 404
      ? 'Página não encontrada'
      : 'Algo deu errado'

  // a page that does not exist is not a bug; anything else (render or loader failure) is
  useEffect(() => {
    if (!isRouteErrorResponse(error) || error.status >= 500) reportError(error)
  }, [error])

  return (
    <main className="app-error">
      <Card roomy>
        <h1>{title}</h1>
        <p>Tente novamente. Se o problema continuar, fale com o atendimento.</p>
        <Button onClick={() => window.location.assign('/')}>Voltar ao início</Button>
      </Card>
    </main>
  )
}
